/**
 * Auto-generated by tools/content-pipeline.
 * Pack: trivia-era-expansion-v1
 * Item: music-70s-expansion
 * Generated: 2026-07-14T01:09:15.282Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 40 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */

export const generatedMusic70s = [
  {
    "question": "Which band famously told us to 'Stayin' Alive' in 1977?",
    "options": [
      "The Bee Gees",
      "KC and the Sunshine Band",
      "Earth, Wind & Fire",
      "Village People"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "The Bee Gees defined the disco sound of the 70s for many, thanks to their work on the Saturday Night Fever soundtrack."
  },
  {
    "question": "Donna Summer was known as the 'Queen of Disco', but what was the title of her 1975 breakthrough hit?",
    "options": [
      "Love to Love You Baby",
      "Bad Girls",
      "Hot Stuff",
      "I Feel Love"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "This song was over 16 minutes long on its album version, helping to define the extended dance track for disco."
  },
  {
    "question": "Which British band released the iconic album 'Led Zeppelin IV' in 1971, featuring 'Stairway to Heaven'?",
    "options": [
      "Led Zeppelin",
      "Black Sabbath",
      "Deep Purple",
      "The Who"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Led Zeppelin IV, despite having no title on its cover, is one of the best-selling albums of all time."
  },
  {
    "question": "Which singer-songwriter topped the charts with 'Sunshine on My Shoulders' in 1974?",
    "options": [
      "John Denver",
      "Gordon Lightfoot",
      "Harry Chapin",
      "Jim Croce"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "John Denver's wholesome image and folk-pop sound made him one of the biggest stars of the 1970s."
  },
  {
    "question": "Which group sang about a 'Bohemian Rhapsody' in 1975, a groundbreaking six-minute rock opera?",
    "options": [
      "Queen",
      "Led Zeppelin",
      "Fleetwood Mac",
      "Pink Floyd"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Queen's epic 'Bohemian Rhapsody' was unusual for its length and complexity, but it became a massive hit anyway."
  },
  {
    "question": "Which soulful singer had a big hit with 'I Shot the Sheriff' in 1974, a reggae song written by Bob Marley?",
    "options": [
      "Eric Clapton",
      "Bill Withers",
      "Marvin Gaye",
      "Stevie Wonder"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Eric Clapton's cover of 'I Shot the Sheriff' brought reggae to a wider rock audience in the 70s."
  },
  {
    "question": "Which British rock band, fronted by Mick Jagger, released the album 'Sticky Fingers' in 1971?",
    "options": [
      "The Rolling Stones",
      "The Who",
      "Led Zeppelin",
      "Pink Floyd"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Sticky Fingers' featured the hit 'Brown Sugar' and is famous for its Andy Warhol-designed zipper cover."
  },
  {
    "question": "Which disco group encouraged everyone to 'Shake Your Booty' in 1976?",
    "options": [
      "KC and the Sunshine Band",
      "The Bee Gees",
      "Earth, Wind & Fire",
      "Kool & the Gang"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "KC and the Sunshine Band were a high-energy funk and disco group known for their catchy dance tunes."
  },
  {
    "question": "Which singer-songwriter released the seminal album 'Tapestry' in 1971?",
    "options": [
      "Carole King",
      "Joni Mitchell",
      "Carly Simon",
      "Laura Nyro"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Tapestry' was a massive success, featuring classics like 'I Feel the Earth Move' and 'You've Got a Friend'."
  },
  {
    "question": "In 1975, which funk/soul band had a major hit with 'Shining Star'?",
    "options": [
      "Earth, Wind & Fire",
      "Kool & the Gang",
      "The Commodores",
      "Rufus"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Earth, Wind & Fire combined funk, soul, jazz, and disco into a distinctive and popular sound."
  },
  {
    "question": "Which iconic British rock band released 'The Wall' in 1979, a rock opera about isolation?",
    "options": [
      "Pink Floyd",
      "Led Zeppelin",
      "The Who",
      "Queen"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'The Wall' explores themes of abandonment and the construction of psychological barriers, and it spawned a hit movie."
  },
  {
    "question": "Which Australian-British band gave us hits like 'How Deep Is Your Love' and 'Night Fever' in the late 70s?",
    "options": [
      "The Bee Gees",
      "Little River Band",
      "Air Supply",
      "Men at Work"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "The Bee Gees achieved superstardom during the disco era, selling millions of records worldwide."
  },
  {
    "question": "Which singer had a major hit with 'American Pie' in 1971, a song about the 'Day the Music Died'?",
    "options": [
      "Don McLean",
      "James Taylor",
      "Cat Stevens",
      "Gordon Lightfoot"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "The epic 'American Pie' is a cultural touchstone that comments on the social and political landscape of the 1960s."
  },
  {
    "question": "Which British rock band, known for dramatic live shows, had a hit with 'We Will Rock You' in 1977?",
    "options": [
      "Queen",
      "Led Zeppelin",
      "Deep Purple",
      "The Who"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'We Will Rock You' is a stadium anthem that remains popular at sporting events around the world."
  },
  {
    "question": "Which group, featuring Stevie Nicks and Lindsey Buckingham, released the hugely successful album 'Rumours' in 1977?",
    "options": [
      "Fleetwood Mac",
      "The Eagles",
      "Heart",
      "Jefferson Starship"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Rumours' is one of the best-selling albums of all time, despite the band's internal drama during its recording."
  },
  {
    "question": "Which Canadian singer-songwriter had a hit with 'Sundown' in 1974?",
    "options": [
      "Gordon Lightfoot",
      "Neil Young",
      "Leonard Cohen",
      "Joni Mitchell"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Gordon Lightfoot was known for his folk and country-folk songs, often with vivid storytelling."
  },
  {
    "question": "What was the name of the Swedish pop group that gave us hits like 'Dancing Queen' and 'Waterloo'?",
    "options": [
      "ABBA",
      "Roxette",
      "Ace of Base",
      "The Cardigans"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "ABBA's catchy pop songs and flamboyant costumes made them one of the most successful acts of the decade."
  },
  {
    "question": "Which singer-songwriter, known for poetic lyrics, released the album 'Blue' in 1971?",
    "options": [
      "Joni Mitchell",
      "Carole King",
      "Carly Simon",
      "Laura Nyro"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "'Blue' is widely considered one of the greatest albums of all time, a deeply personal and influential work."
  },
  {
    "question": "In 1978, which band had a number one hit with 'Kiss You All Over'?",
    "options": [
      "Exile",
      "Bread",
      "Ambrosia",
      "Player"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "Exile was a country-pop band that started in the 60s, but found their biggest success with this smooth pop ballad."
  },
  {
    "question": "Which artist had a hit in 1976 with 'Sir Duke', a tribute to jazz legends?",
    "options": [
      "Stevie Wonder",
      "Earth, Wind & Fire",
      "Kool & the Gang",
      "Marvin Gaye"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "'Sir Duke' was a vibrant celebration of jazz greats like Duke Ellington, Count Basie, and Glenn Miller."
  },
  {
    "question": "Which singer-songwriter had a hit with 'Fire and Rain' in 1970?",
    "options": [
      "James Taylor",
      "Cat Stevens",
      "Jim Croce",
      "Harry Chapin"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Fire and Rain' is a deeply personal song detailing Taylor's struggles with depression and loss."
  },
  {
    "question": "Which band had a major hit with 'More Than a Feeling' in 1976?",
    "options": [
      "Boston",
      "Foreigner",
      "Journey",
      "Styx"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Boston's debut album, featuring 'More Than a Feeling', sold millions and became one of the best-selling debut albums ever."
  },
  {
    "question": "Which iconic rock band released the album 'Dark Side of the Moon' in 1973?",
    "options": [
      "Pink Floyd",
      "Led Zeppelin",
      "The Who",
      "Queen"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Dark Side of the Moon' is one of the most successful and critically acclaimed albums of all time."
  },
  {
    "question": "Which singer-songwriter had a hit with 'Bad, Bad Leroy Brown' in 1973?",
    "options": [
      "Jim Croce",
      "Harry Chapin",
      "John Denver",
      "Gordon Lightfoot"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Jim Croce was a masterful storyteller whose songs painted vivid pictures of everyday life."
  },
  {
    "question": "Which band had a hit in 1977 with 'Go Your Own Way'?",
    "options": [
      "Fleetwood Mac",
      "The Eagles",
      "Heart",
      "Boston"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Go Your Own Way' was written by Lindsey Buckingham about his tumultuous relationship with Stevie Nicks."
  },
  {
    "question": "In 1978, which artist released the disco hit 'Last Dance'?",
    "options": [
      "Donna Summer",
      "Gloria Gaynor",
      "Diana Ross",
      "Chic"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "'Last Dance' won an Academy Award for Best Original Song and became a signature tune for Donna Summer."
  },
  {
    "question": "Which folk icon had his first hit as a solo artist in 1972 with 'Mother and Child Reunion'?",
    "options": [
      "Paul Simon",
      "Art Garfunkel",
      "Bob Dylan",
      "Leonard Cohen"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "Paul Simon recorded 'Mother and Child Reunion' in Jamaica, incorporating reggae influences into his sound."
  },
  {
    "question": "Which band, led by Ann and Nancy Wilson, had a hit with 'Barracuda' in 1977?",
    "options": [
      "Heart",
      "Fleetwood Mac",
      "Jefferson Starship",
      "Pat Benatar"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Heart blended hard rock with folk influences, and the Wilson sisters were trailblazers for women in rock."
  },
  {
    "question": "Which soul group had a hit with 'ABC' in 1970, and was fronted by a young Michael Jackson?",
    "options": [
      "The Jackson 5",
      "The Commodores",
      "Earth, Wind & Fire",
      "The Temptations"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "The Jackson 5 were a major Motown act who enjoyed enormous success in the early 70s with their catchy pop-soul songs."
  },
  {
    "question": "Which singer-songwriter had a hit with 'Maggie May' in 1971?",
    "options": [
      "Rod Stewart",
      "Elton John",
      "Cat Stevens",
      "James Taylor"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "'Maggie May' was a breakthrough hit for Rod Stewart, mixing folk-rock with blues influences."
  },
  {
    "question": "Which band had a hit with 'Carry On Wayward Son' in 1976?",
    "options": [
      "Kansas",
      "Styx",
      "Journey",
      "REO Speedwagon"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Kansas was known for their progressive rock sound, combining elements of classical music with hard rock."
  },
  {
    "question": "Which iconic duo sang 'Bridge Over Troubled Water' in 1970?",
    "options": [
      "Simon & Garfunkel",
      "The Carpenters",
      "Everly Brothers",
      "The Righteous Brothers"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Bridge Over Troubled Water' was a global hit and is considered one of the greatest songs ever written."
  },
  {
    "question": "Which rock band, known for their powerful blues-rock sound, released the album 'Rocks' in 1976?",
    "options": [
      "Aerosmith",
      "Led Zeppelin",
      "AC/DC",
      "Kiss"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "'Rocks' is often cited by other bands as a major influence on hard rock and heavy metal."
  },
  {
    "question": "Which artist had a hit in 1971 with 'It's Too Late'?",
    "options": [
      "Carole King",
      "Joni Mitchell",
      "Carly Simon",
      "Roberta Flack"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'It's Too Late' was Carole King's biggest selling single and a highlight from her 'Tapestry' album."
  },
  {
    "question": "Which band, featuring Freddie Mercury, released the album 'A Night at the Opera' in 1975?",
    "options": [
      "Queen",
      "Led Zeppelin",
      "Pink Floyd",
      "The Who"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'A Night at the Opera' is considered one of Queen's finest albums, producing the legendary 'Bohemian Rhapsody'."
  },
  {
    "question": "In 1970, which singer-songwriter had a hit with 'Wild World'?",
    "options": [
      "Cat Stevens",
      "James Taylor",
      "John Denver",
      "Carole King"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "Cat Stevens (now Yusuf Islam) had many contemplative and melodic folk-pop hits in the early 70s."
  },
  {
    "question": "Which rock band had a hit with 'Sweet Home Alabama' in 1974?",
    "options": [
      "Lynyrd Skynyrd",
      "The Allman Brothers Band",
      "ZZ Top",
      "Creedence Clearwater Revival"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Sweet Home Alabama' became an anthem for Southern rock and is still widely played today."
  },
  {
    "question": "What was the title of Elton John's 1973 album that featured hits like 'Candle in the Wind' and 'Bennie and the Jets'?",
    "options": [
      "Goodbye Yellow Brick Road",
      "Honky Château",
      "Caribou",
      "Captain Fantastic and the Brown Dirt Cowboy"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "This double album is considered one of Elton John's most ambitious and successful works."
  },
  {
    "question": "Which artist had a hit in 1974 with 'Rhinestone Cowboy'?",
    "options": [
      "Glen Campbell",
      "Kenny Rogers",
      "Merle Haggard",
      "Charley Pride"
    ],
    "correctIndex": 0,
    "difficulty": "easy",
    "blurb": "'Rhinestone Cowboy' was a massive crossover hit for Glen Campbell, topping both country and pop charts."
  },
  {
    "question": "Which influential German electronic band released the album 'Trans-Europe Express' in 1977?",
    "options": [
      "Kraftwerk",
      "Tangerine Dream",
      "Can",
      "Neu!"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "Kraftwerk were pioneers of electronic music and paved the way for many genres, including hip-hop and techno."
  }
] as const;
